module.exports = __webpack_public_path__ + "static/media/thank_you_screen_image.a63411f7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/flavours/arrivaClick/images/thank_you_screen_image.svg
// module id = 569
// module chunks = 0